import React, { useEffect } from "react";
import { setResponsiveImage } from "../../helpers";
import "./index.scss";
import queryString from "query-string";

const heroImage = "../../assets/images/Homepage_photo.png";
const heroImage1 = "../../assets/images/homepage_section_bg.png";
const heroImage2 = "../../assets/images/homepage_thumb.png";

export const setUpTabs = (
  defaultTab: number = 0,
  tabClass: string = "success-stories"
) => {
  // initial
  const initialTab = document.querySelector(
    `.${tabClass}__tabs-content [data-tab-content="${defaultTab}"]`
  );
  initialTab &&
    initialTab.classList.add(`${tabClass}__tabs-content-item--active`);

  const initialTabHeader = document.querySelector(
    `.${tabClass}__tabs [data-tab-index="${defaultTab}"]`
  );
  if (initialTabHeader && initialTabHeader !== null) {
    initialTabHeader &&
      // @ts-ignore
      initialTabHeader
        .closest(`.${tabClass}__tab-header`)
        .classList.add(`active`);
  }

  // click handle
  const tabHeaders = document.querySelectorAll(`.${tabClass}__tab-header`);
  tabHeaders &&
    tabHeaders.forEach(header => {
      header.addEventListener("click", e => {
        e.preventDefault();
        // @ts-ignore
        const tabIndex = e.target && e.target.getAttribute("data-tab-index");

        // update url
        let qs: any = queryString.parse(location.search);
        qs["success-story-index"] = tabIndex;
        var url = window.location.href;
        var urlSplit = url.split("?");
        history.replaceState(
          {},
          "",
          urlSplit[0] + "?" + queryString.stringify(qs)
        );

        // remove class from tab title
        const activeTabHeader = document.querySelector(
          `.${tabClass}__tab-header.active`
        );
        activeTabHeader && activeTabHeader.classList.remove(`active`);

        // add class to tab title
        e.target &&
          // @ts-ignore
          e.target.closest(`.${tabClass}__tab-header`).classList.add(`active`);

        // remove active class from other tabs
        const activeTab = document.querySelector(
          `.${tabClass}__tabs-content-item--active`
        );
        activeTab &&
          activeTab.classList.remove(`${tabClass}__tabs-content-item--active`);

        // add active class to the tab to show
        const tabToShow = document.querySelector(
          `.${tabClass}__tabs-content [data-tab-content="${tabIndex}"]`
        );
        tabToShow &&
          tabToShow.classList.add(`${tabClass}__tabs-content-item--active`);
      });
    });
};

export const successStoriesInit = (initParams: {
  images: {
    mobileImage: string;
    tabletImage: string;
    desktopImage: string;
  }[];
  elClassName: string;
}) => {
  const { images, elClassName } = initParams;

  for (let i = 0; i < images.length; i++) {
    setResponsiveImage({
      mobileImage: images[i].mobileImage,
      tabletImage: images[i].tabletImage,
      desktopImage: images[i].desktopImage,
      elClassName: `${elClassName}--${i}`
    });
  }

  // check qs here and set up as initial value - also update qs on click
  let search: any = queryString.parse(location.search);
  setUpTabs(search["success-story-index"]);
};

const SuccessStories = () => {
  useEffect(() => {
    successStoriesInit({
      images: [
        {
          mobileImage: heroImage,
          tabletImage: heroImage,
          desktopImage: heroImage
        },
        {
          mobileImage: heroImage1,
          tabletImage: heroImage1,
          desktopImage: heroImage1
        },
        {
          mobileImage: heroImage2,
          tabletImage: heroImage2,
          desktopImage: heroImage2
        }
      ],
      elClassName: "success-stories__bg"
    });
  });

  return (
    <div className="success-stories" id="success-stories">
      <div className="success-stories__title">
        <h2>Success Stories</h2>
      </div>
      <div className="success-stories__content">
        <div className="success-stories__tabs-container">
          <div className="container">
            <div className="success-stories__tabs">
              <ul>
                <li className="success-stories__tab-header">
                  <a data-tab-index="0" href="#0">
                    Andy Murray
                  </a>
                </li>
                <li className="success-stories__tab-header">
                  <a data-tab-index="1" href="#0">
                    Roger Federer
                  </a>
                </li>
                <li className="success-stories__tab-header">
                  <a data-tab-index="2" href="#0">
                    Rafa Nadal
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="success-stories__tabs-content">
          <div
            data-tab-content="0"
            className="success-stories__tabs-content-item"
          >
            <div className="success-stories__bg success-stories__bg--0" />
            <div className="container">
              <div className="success-stories__text-container">
                <div className="success-stories__text">
                  <p>
                    <strong>Heading about Andy</strong>
                  </p>
                  <h3>Some heading</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam.
                  </p>
                  <p>
                    Quam adipiscing vitae proin sagittis nisl rhoncus. Ornare
                    suspendisse sed nisi lacus sed viverra tellus in hac. Lorem
                    ipsum dolor sit amet consectetur adipiscing elit
                    pellentesque. Lorem sed risus ultricies tristique nulla
                    aliquet. Nunc eget lorem dolor sed viverra.
                  </p>
                </div>
                <div className="success-stories__quote-text">
                  <div>
                    <q>
                      Quam adipiscing vitae proin sagittis nisl rhoncus. Ornare
                      suspendisse sed nisi lacus sed viverra tellus in hac.
                    </q>
                    <p>
                      <strong>Andy Murray</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-tab-content="1"
            className="success-stories__tabs-content-item"
          >
            <div className="success-stories__bg success-stories__bg--1" />
            <div className="container">
              <div className="success-stories__text-container">
                <div className="success-stories__text">
                  <p>
                    <strong>Heading about Roger</strong>
                  </p>
                  <h3>Some heading</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam.
                  </p>
                  <p>
                    Quam adipiscing vitae proin sagittis nisl rhoncus. Ornare
                    suspendisse sed nisi lacus sed viverra tellus in hac. Lorem
                    ipsum dolor sit amet consectetur adipiscing elit
                    pellentesque. Lorem sed risus ultricies tristique nulla
                    aliquet. Nunc eget lorem dolor sed viverra.
                  </p>
                </div>
                <div className="success-stories__quote-text">
                  <div>
                    <q>
                      Quam adipiscing vitae proin sagittis nisl rhoncus. Ornare
                      suspendisse sed nisi lacus sed viverra tellus in hac.
                    </q>
                    <p>
                      <strong>Andy Murray</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-tab-content="2"
            className="success-stories__tabs-content-item"
          >
            <div className="success-stories__bg success-stories__bg--2" />
            <div className="container">
              <div className="success-stories__text-container">
                <div className="success-stories__text">
                  <p>
                    <strong>Heading about Rafa</strong>
                  </p>
                  <h3>Some heading</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam.
                  </p>
                  <p>
                    Quam adipiscing vitae proin sagittis nisl rhoncus. Ornare
                    suspendisse sed nisi lacus sed viverra tellus in hac. Lorem
                    ipsum dolor sit amet consectetur adipiscing elit
                    pellentesque. Lorem sed risus ultricies tristique nulla
                    aliquet. Nunc eget lorem dolor sed viverra.
                  </p>
                </div>
                <div className="success-stories__quote-text">
                  <div>
                    <q>
                      Quam adipiscing vitae proin sagittis nisl rhoncus. Ornare
                      suspendisse sed nisi lacus sed viverra tellus in hac.
                    </q>
                    <p>
                      <strong>Andy Murray</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;
